import React, { useState, useEffect } from "react";
import styled from "styled-components";

import { connect } from 'react-redux'
import { jumpTo } from "../../../utils";
import { getDonateUserRanking, fetchAppRelation, fetchAppRelationDelete } from '../api'
import { Toast } from "antd-mobile";
import bridge from '@/config/JSbridge'
import bwmodel from '@/config/bwmodel';
import react1Png from '../image/rect1.png';
import react2Png from '../image/rect2.png';
import paiming1 from '../image/paiming1.png';
import paiming2 from '../image/paiming2.png';
import paiming3 from '../image/paiming3.png';


const isStorm = bwmodel.app !== 'storm';
const Delivery = ({userId, token}) => {
  const [rankList, setRankList] = useState([{},{},{},{},{},{},{},{},{},{}]);

  useEffect(()=> {
    getDonateUserRanking({})
      .then(res => {
        if(res.length > 0) { 
          setRankList(res)
        }
      })
  },[])


  const handleLogin = (cb) => {
		if(!isStorm) {
			window.location.href = "https://m.wogoo.com/app/download/wogoo_client/index.html"
		}
    bridge.callHandler(
      'nativeEvent',
      {
        event: 'login',
        params: {
          refreshOnBack: true
        }
      },
      () => {}
    );
    
  }

  function handleAppRelation(row) {
    const id = row.userId;
    const params = {
      C_FOLLOWEE_ID: id
    }
    
    if(!token) {
      return  handleLogin()
    } 
  

    if(row.isFollow === 0) {
      fetchAppRelation(params)
      .then(res => {
        if(res.resultCode === '00') {
          Toast.info('关注成功')
          const rusult = rankList.map(it => {
            if(it.userId === id ) {
              it.isFollow = 1;
            } 
            return it;
          })
          
          setRankList(rusult)
        }
        
      })

    } else {
      fetchAppRelationDelete(params)
      .then(res => {
        if(res.resultCode === '00') {
          Toast.info('取消关注成功')
        const rusult = rankList.map(it => {
            if(it.userId === id ) {
              it.isFollow = 0;
            } 
            return it;
          })
          
          setRankList(rusult)
        }
      })
    }
  }

  return (
    <div>
    <img src={require('../image/bg1.png')} alt=""></img>

    <Originator>
        
      <div className="title-box">
        <div className="title">
          创作者收入榜单
        </div>
      </div>
      <div className="user_boxs">
        {
          rankList.length > 1 &&  <div className="user_box end">
            <div className="avatar" onClick={
           
                () => jumpTo(`storm://app/userzone?userID=${rankList[1].userId}&userName=${rankList[1].nickname}`)
                }>
                <img src={rankList[1].avatar} alt=""/>
                <div className="rank rank1"></div>
              </div>
              <div className="name" onClick={
                () => jumpTo(`storm://app/userzone?userID=${rankList[1].userId}&userName=${rankList[1].nickname}`)
                }>{rankList[1].nickname}</div>
             {
                rankList[1].amount && <div className="awards">{rankList[0].amount?parseInt(rankList[1].amount, 10):0}元</div>
              }
            </div>
        }
     
     {
          rankList.length > 0 && <div className="user_box long">
            <div className="avatar" onClick={
                () => jumpTo(`storm://app/userzone?userID=${rankList[0].userId}&userName=${rankList[0].nickname}`)
              }>
              <img src={rankList[0].avatar} alt=""/>
              <div className="rank rank0"></div>
            </div>
            <div className="name" onClick={
                () => jumpTo(`storm://app/userzone?userID=${rankList[0].userId}&userName=${rankList[0].nickname}`)
              }>{rankList[0].nickname}</div>
          {
              rankList[0].amount && <div className="awards">{rankList[0].amount?parseInt(rankList[0].amount, 10):0}元</div>
            }
            
          </div>
          }
       
       {
         rankList.length > 2 && 
          <div className="user_box end">
            <div className="avatar" onClick={
              
              () => jumpTo(`storm://app/userzone?userID=${rankList[2].userId}&userName=${rankList[2].nickname}`)
            }>
              <img src={rankList[2].avatar} alt=""/>
              <div className="rank rank2"></div>
            </div>
            <div className="name" onClick={
                () => jumpTo(`storm://app/userzone?userID=${rankList[2].userId}&userName=${rankList[2].nickname}`)
                }>{rankList[2].nickname}</div>
            {
                rankList[2].amount && <div className="awards">{rankList[0].amount?parseInt(rankList[2].amount, 10):0}元</div>
              }
          </div>
       }
      </div>
      {/* <div className="podium">
        <img src={require(`../imgs/img40.png`)} alt=""></img>
      </div> */}
      <div className="list">
      <div className="list_item header">
          <div className="rank">排名</div>
          <div className="name">创作者昵称</div>
          {/* <div className="follow"></div> */}
          <div className="awards">创作者收入</div>
        </div>
        {
         rankList.length > 4 && rankList.map((it,index) => {
            return (
              index > 2? 
              <div className="list_item">
                  <div className="rank">{index + 1}</div>
                  <div className="name" onClick={
                    () => jumpTo(`storm://app/userzone?userID=${it.userId}&userName=${it.nickname}`)
                  }>
                  <div>{it.nickname}</div>
                </div>
                
            
                {/* <div className='follow'>
                {
                  userId !== it.userId ? <div className="status" onClick={()=> handleAppRelation(rankList[0])}>{rankList[0].isFollow === 0 ? '关注': '已关注'}</div> : ''
                }
                </div> */}

                {
                  it.amount &&  <div className="awards">{it.amount?parseInt(it.amount, 10):0} 元</div>
                }
              </div>
              :""
            )
          })
        }
      </div>
      <div onClick={()=>handleAppRelation()} style={{display:"none"}}>隐藏</div>
    </Originator>
    </div>
  )
}

const mapStateToProps = (state) => {
  // console.log(state);
  return {
    token: state.user.accessToken || '',
    userId: state.user.userId
  }
}


export default React.memo(connect(mapStateToProps)(Delivery));
// export default React.memo(forwardRef(Delivery));

export const Originator = styled.div`
  background: #FFFFFF;
  margin: -27vw 13px 0;
  padding-top: 20px;
  border-radius: 10px 10px;
  position: relative;
  z-index: 1;
  .title-box {
    font-size: 20px;
    text-align: center;
    font-weight: bold;
    color: #7C422F;
  }
  .user_boxs {
    display: flex;
    justify-content: space-between;
    margin: 0 20px;
    align-items: end;
    padding-top: 20px;
  }
  .user_box {
    position: relative;
    flex:1;
    width: 30%;
    height: 150px;
    margin: 5px;
    background-image: url(${react2Png});
    background-repeat: no-repeat;
    background-size: contain; 
    background-position:0 100%;
    text-align: center;
    &.long{
      height: 150px;
      background-image: url(${react1Png});
    }
    
    &.end {
      .avatar {
        top: 18px;
      }
    }
    .avatar {
      margin: auto;
      position: relative;
      img {
        width: 68px;
        height: 68px;
        user-select: none;
        border-radius:50%;
        border: 2px solid #FFE869;
      }
      .rank {
        position: absolute;
        left: 50%;
        bottom: -8px;
        transform: translateX(-50%);
        color:#Ffffff;
        font-weight: bold;
        z-index:100;
        width: 51px;
        height: 33px;
        line-height: 17px;
        background-size:contain;

        &.rank0 {
          background-image: url(${paiming1});
        }
        &.rank1 {
          background-image: url(${paiming2});
        }
        &.rank2 {
          background-image: url(${paiming3});
          
        }
      }

    }
    .name, .awards {
      position: absolute;
      left: 0%;
      width: 100%;
      text-align: center;
    }
    .name {
      bottom: 30px;
      font-weight: 500;
      font-size: 14px;
      color: #010101;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }

    .follow {
      width: 70px;
    }
    .status {
      margin: auto;
      width: 60px;
      height: 24px;
      text-align:center;
      line-height: 24px;
      border-radius: 12px;
      background: linear-gradient(270deg, #FF6C00 0%, #FF9B00 100%);
      color: #ffffff;
    }
    .awards {
       bottom: 10px;
      font-weight: 500;
      font-size: 15px;
      color: #BD3601;
    }

  }
  .list {
    // min-height: 40vh;
 
    // margin: 0 20px;

  }

  .list_item {
    &:nth-child(2n+3){
      background: #FFEFD9;
    }
    &.header {
      font-weight: 400;
      font-size: 12px;
      color: #606060;
      .name, .awards {
        font-size: 12px;
        color: #606060;
        font-weight: 400;
      }
      .rank {
        font-weight: 400;
      }
      .awards {
        text-align: center
      }
    }
    padding: 10px 15px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .avatar {
      height: 36px;
      width: 36px;
      border-radius:18px;
     
      background:none;
      min-width: 36px;
      position: relative;
      img {
        user-select: none;
         border: 1px solid #FFE869;
        height: 36px;
        width: 36px;
        border-radius:18px;
        // width: 100%;
        // height: 100%;
      }
   

    }
    .rank {
  
      text-align: center;
      width: 30px;
      height: 14px;
     
      line-height: 14px;
      font-size: 13px;
      font-weight: bold;
      color:#606060;
    
    }
    .name {
      font-weight: 500;
      font-size: 15px;
      color: #606060;
      flex: 1;
       padding-left: 10px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      >div {
        width: 200px;
        max-width:120px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
     
    }
    .status {
      width: 60px;
      height: 24px;
      border: 2px solid #ff9b00;
      text-align:center;
      line-height: 24px;
      border-radius: 12px;
      color: #ff9b00;
      margin-left: 5px;
    }
    .awards {
      font-weight: bold;
      font-size: 15px;
      color: #606060;
      width: 70px;
      text-align: right;
    }
  }
  .podium {
    padding: 0 20px;
    font-size: 0;
    margin-bottom: -1px;
    img {
      width: 100%;

    }
  }
`;



// WEBPACK FOOTER //
// ./src/views/activity_130/components/Originator.js